import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {TaskService} from '../../../../services/task.service';

@Component({
  selector: 'app-timing-status-group-moving',
  templateUrl: './timing-status-group-moving.component.html',
  styleUrls: ['../parts.css']
})
export class TimingStatusGroupMovingComponent implements OnInit {

  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据

  // 分组
  groupConditionVisible: boolean; // 分组POP是否关闭
  groupConditionId = null; // 分组选中ID
  groupConditionDisplayText = '分组'; // 条件二默认文字

  // 定时
  schedulerConditionDisplayText = '定时'; // 定时默认文字
  schedulerConditionData: any; // 存放定时数据
  schedulerConditionVisible: boolean; // 定时pop是否关闭

  statusColumnDisplayText = '状态'; // 状态列显示文字
  statusPopVisible = false; // 状态列pop显示
  statusColumnList = []; // 状态列可选值

  columnValueDisplayText = '某个值'; // 状态列的值的默认文字
  columnValuePopVisible = false; // 状态列值pop显示
  columnValueList = []; // 状态列值可选择值

  targetGroupVisible = false;
  targetGroupId = null;
  targetGroupDisplayText = '分组';

  mailPopVisible = false;
  receiverPopVisible = false;
  smsPattern = 'custom';
  smsTemplateList;
  notificationData: any; // 存放通知组件数据

  // 其他
  isVisible = false; // 弹窗显示控制
  isConfirmLoading = false; // 确定按钮
  recipeId = null; // 自动化模板ID
  relationId;
  instanceData: any = {}; // 存放实例返填数据
  backFillData: any; // 回填数据
  categorieId: string; // 存放当前目录ID

  automation = {
    boardId: '',
    columnId: '',
    categoryId: '',
    relationId: '',
    groupId: '',
    targetGroupId: '',
    email: null,
    siteMessage: null,
    sms: null,
    columnValue: {
      index: null,
      indexes: []
    },
    receiver: {
    },
    schedulerDescription: '',
    schedulerConfig: {},
    instanceDescription: ''
  }; // 存放入参数据
  @ViewChild('pulseIntegration') pulseIntegration: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService
  ) { }

  ngOnInit(): void {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
      if (this.boardColumnData && this.boardColumnData.length > 0) {
        for (const column of this.boardColumnData) {
          if (column.type === 'status') {
            this.statusColumnList.push(column);
          } else if (column.type === 'taskProgress') {
            this.statusColumnList.push(column);
          }
        }
      }
    }
    // 初始化自动化数据
    console.log(this.instanceData);
    if (this.instanceData && this.instanceData.config) {
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      this.schedulerConditionData = this.instanceData.config.schedulerConfig;
      this.schedulerConditionDisplayText =
        this.instanceData.config.schedulerDescription ? this.instanceData.config.schedulerDescription : '定时';
      if (this.automation.groupId) {
        this.groupConditionId = this.automation.groupId;
        const groupNames = [];
        for (const group of this.boardGroupData) {
          if (this.groupConditionId.includes(group.id)) {
            group.checked = true;
            groupNames.push(group.title);
          }
        }
        this.groupConditionDisplayText = groupNames.join(',');
        this.groupConditionDisplayText = this.groupConditionDisplayText.length > 12 ?
          `${this.groupConditionDisplayText.slice(0, 12)}...` : this.groupConditionDisplayText;
      }
      if (this.automation.columnId && this.statusColumnList.length > 0) {
        for (const statusColumn of this.statusColumnList) {
          if (statusColumn.id === this.automation.columnId) {
            this.statusColumnDisplayText = statusColumn.title;
            this.columnValueList = statusColumn.labels;
            for (const label of this.columnValueList) {
              if (label.index === this.automation.columnValue.index) {
                this.columnValueDisplayText = label.label;
                break;
              }
            }
            break;
          }
        }
      }
      if (this.automation.targetGroupId) {
        this.targetGroupId = this.automation.targetGroupId;
        for (const group of this.boardGroupData) {
          if (this.targetGroupId === group.id) {
            this.targetGroupDisplayText = group.title;
          }
        }
      }
      this.getStatusValueText();
      this.notificationData = this.instanceData.config.email || this.instanceData.config.siteMessage || this.instanceData.config.sms;
    }
    if (this.smsPattern === 'template') {
      this.taskService.querySmsTemplateList().subscribe(res => {
        this.smsTemplateList = res;
        if (this.smsTemplateList && this.smsTemplateList.length > 0) {
          for (const template of this.smsTemplateList) {
            template['content'] = JSON.parse(template['content']);
          }
        }
      });
    }
    // 带入菜单ID
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    this.packageData();
  }

  // 分组变更
  groupConditionChange(item) {
    item.checked = !item.checked;
    this.getGroupIds();
    this.automation.groupId = this.groupConditionId;
    this.packageData();
  }

  getGroupIds() {
    const idSet = new Set();
    const groupNames = [];
    for (const group of this.boardGroupData) {
      if (group.checked) {
        idSet.add(group.id);
        groupNames.push(group.title);
      }
    }
    const ids = Array.from(idSet);
    this.groupConditionId = ids.join(',');
    this.groupConditionDisplayText = groupNames.join(',');
    this.groupConditionDisplayText = this.groupConditionDisplayText.length > 12 ?
      `${this.groupConditionDisplayText.slice(0, 12)}...` : this.groupConditionDisplayText;
  }

  statusSelectChange(item) {
    this.statusColumnDisplayText = item.title;
    this.automation.columnId = item.id;
    this.statusPopVisible = false;
    this.columnValueList = item.labels;
    this.automation.columnValue.index = null;
    this.columnValueDisplayText = '某个值';
    this.packageData();
  }

  columnValueSelectChange(item) {
    const i = this.automation.columnValue.indexes.findIndex((index) => index === item.index);
    if (i > -1) {
      this.automation.columnValue.indexes.splice(i, 1);
    } else {
      this.automation.columnValue.indexes.push(item.index);
    }
    this.getStatusValueText();
    this.packageData();
  }

  getStatusValueText() {
    const texts = [];
    for (const item of this.columnValueList) {
      if (this.automation.columnValue.indexes.includes(item.index)) {
        texts.push(item.label);
      }
    }
    this.columnValueDisplayText = texts.join('或');
  }

  getNotificationData(data) {
    this.notificationData = data.content;
    if (data.type === 'email') {
      this.automation.email = data.content;
      this.automation.siteMessage = null;
      this.automation.sms = null;
    } else if (data.type === 'siteMessage') {
      this.automation.siteMessage = data.content;
      this.automation.email = null;
      this.automation.sms = null;
    } else {
      this.automation.sms = data.content;
      this.automation.email = null;
      this.automation.siteMessage = null;
    }
    this.mailPopVisible = false;
    this.packageData();
  }

  getUserData(data) {
    this.automation.receiver = data;
    this.packageData();
  }

  targetGroupChange(group) {
    this.targetGroupId = group.id;
    this.automation.targetGroupId = group.id;
    this.targetGroupDisplayText = group.title;
    this.targetGroupVisible = false;
    this.packageData();
  }

  packageData() {
    this.automation.instanceDescription = '在 ' + this.groupConditionDisplayText + ' 中，' + this.schedulerConditionDisplayText + ', 当 ' + this.statusColumnDisplayText
      + ' 变更为 ' + this.columnValueDisplayText + ' 时，将任务移动到 ' + this.targetGroupDisplayText;
    this.nfDataChange.emit(this.automation);
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus(): boolean {
    return this.automation.groupId &&
      this.automation.columnId &&
      this.automation.targetGroupId &&
      this.automation.columnValue.indexes != null && this.automation.columnValue.indexes.length > 0;
  }

  // 获取定时数据
  getSchedulerData(event) {
    this.schedulerConditionVisible = false;
    this.schedulerConditionDisplayText = event.text;
    this.schedulerConditionData = event.config;
    this.automation.schedulerDescription = this.schedulerConditionDisplayText;
    this.automation.schedulerConfig = this.schedulerConditionData;
    this.packageData();
  }

}
